
import {
  computed, defineComponent, ref,
} from 'vue';
import { NETWORK_CONTACT_TYPES, REQUEST_TYPE } from '@/types/enums';
import { useSpacesStore } from '../store/spacesStore';
import SpacesUser from './SpacesUser.vue';
import SpacesGroup from '@/modules/spaces/components/SpacesGroup.vue';
import SpacesUserTransition from './SpacesUserTransition.vue';
import AppItemWrapper from '@/components/AppItemWrapper.vue';
import AppSkeletonContact from '@/components/skeletons/AppSkeletonContact.vue';
import { IGroupData, IRequestSpaces } from '@/types/interfaces';

export default defineComponent({
  props: {
    invitations: { type: Array as () => IRequestSpaces[], required: true },
    skeleton: { type: Boolean, default: false },
  },
  components: {
    SpacesUser,
    SpacesGroup,
    SpacesUserTransition,
    AppItemWrapper,
    AppSkeletonContact,
  },
  emits: ['open-group'],
  setup(props, { emit }) {
    const spacesStore = useSpacesStore();
    const showAll = ref(false);

    const incoming = computed(() => {
      if (!showAll.value) {
        return props.invitations.length <= 10 ? props.invitations : props.invitations.slice(0, 10);
      }
      return props.invitations;
    });

    function openGroupInfo(group: IGroupData) {
      emit('open-group', group);
    }

    return {
      spacesStore,
      incoming,
      NETWORK_CONTACT_TYPES,
      REQUEST_TYPE,
      showAll,
      openGroupInfo,
    };
  },
});
